import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../components/HelloWorld.vue'
import DetailPage from '../components/DetailPage.vue'
import HyDetailPage from '../components/HyDetailPage.vue'
import MorePage from '../components/MorePage.vue'
import QaPage from '../components/QAPage.vue'
const routes = [
  {
    path: '/qyhg',
    redirect: 'index',
    component: HomeView
  },
  {
    path: '/index',
    name: 'home',
    component: HomeView
  },
  {
    path: '/',
    name: 'index',
    component: HomeView
  },
  {
    path: '/detail',
    name: 'detail',
    component: DetailPage
  },
  {
    path: '/hydetail',
    name: 'hydetail',
    component: HyDetailPage
  },
  {
    path: '/morepage',
    name: 'morepage',
    component: MorePage
  },
  {
    path: '/qapage',
    name: 'qapage',
    component: QaPage
  },
  {
    path: '/sourceAiEnhance',
    component: () => import('@/views/sourceAiEnhance/index'),
    name: 'sourceAiEnhance',
    meta: { title: '知识对话' }
  },
]

const router = createRouter({
  history: createWebHistory(''),
  routes
})

export default router
